export default [

     {
          path: '/initiative',
          name: 'Initiative',
          component: () => import("@/views/Page/StrategicPlan/Initiative/Initiative.vue"),
          meta: {
               title: 'Initiative',
          },
     }
];